(function () {
  'use strict';

  function DawnProduct(root) {
    this.root = root;
    this.form = root.querySelector('.dp-form');
    this.config = parseJson(root.querySelector('[data-dp-product-data]'));
    this.variants = this.config.variants || [];
    this.variantIdInput = root.querySelector('[data-dp-variant-id]');
    this.optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-dp-option-position]'));
    this.submitButton = root.querySelector('[data-dp-submit]');
    this.submitLabel = root.querySelector('[data-dp-submit-label]');
    this.spinner = root.querySelector('[data-dp-spinner]');
    this.formError = root.querySelector('[data-dp-form-error]');
    this.quantityInput = root.querySelector('[data-dp-quantity]');
    this.quantityMessage = root.querySelector('[data-dp-quantity-message]');
    this.price = root.querySelector('[data-dp-price]');
    this.comparePrice = root.querySelector('[data-dp-compare-price]');
    this.saleBadge = root.querySelector('[data-dp-sale-badge]');
    this.inventory = root.querySelector('[data-dp-inventory]');
    this.notification = root.querySelector('[data-dp-notification]');
    this.zoomDialog = root.querySelector('[data-dp-zoom-dialog]');
    this.loading = false;
    this.lastFocusedElement = null;
    this.currentVariant = this.findVariantById(Number(this.variantIdInput && this.variantIdInput.value));

    this.sortOptionValues();
    this.bindEvents();
    this.setupRecipientForm();
    this.updateVariant(this.currentVariant, false);
  }

  DawnProduct.prototype.bindEvents = function () {
    var self = this;

    this.root.querySelectorAll('[data-dp-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.updateOptionAvailability(true);
        self.updateVariant(self.findSelectedVariant(), true);
      });
    });

    var minus = this.root.querySelector('[data-dp-quantity-minus]');
    var plus = this.root.querySelector('[data-dp-quantity-plus]');
    if (minus) minus.addEventListener('click', function () { self.stepQuantity(-1); });
    if (plus) plus.addEventListener('click', function () { self.stepQuantity(1); });
    if (this.quantityInput) {
      this.quantityInput.addEventListener('input', function () { self.validateQuantity(true); });
      this.quantityInput.addEventListener('change', function () { self.normalizeQuantity(); });
    }

    if (this.form) this.form.addEventListener('submit', function (event) { self.addToCart(event); });

    this.root.querySelectorAll('[data-dp-notification-close]').forEach(function (button) {
      button.addEventListener('click', function () { self.closeNotification(); });
    });

    this.root.querySelectorAll('[data-dp-zoom]').forEach(function (button) {
      button.addEventListener('click', function () { self.openZoom(button); });
    });

    var zoomClose = this.root.querySelector('[data-dp-zoom-close]');
    if (zoomClose) zoomClose.addEventListener('click', function () { self.closeZoom(); });
    if (this.zoomDialog) {
      this.zoomDialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        self.closeZoom();
      });
      this.zoomDialog.addEventListener('click', function (event) {
        if (event.target === self.zoomDialog) self.closeZoom();
      });
    }

    var share = this.root.querySelector('[data-dp-share]');
    if (share) share.addEventListener('click', function () { self.share(share); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.notification && !self.notification.hidden) {
        self.closeNotification();
      }
    });
  };

  DawnProduct.prototype.findVariantById = function (id) {
    return this.variants.find(function (variant) { return Number(variant.id) === Number(id); }) || this.variants[0] || null;
  };

  DawnProduct.prototype.sortOptionValues = function () {
    this.optionGroups.forEach(function (group) {
      var container = group.querySelector('.dp-option-values');
      if (!container) return;

      var entries = Array.prototype.slice.call(group.querySelectorAll('[data-dp-option-input]')).map(function (input, index) {
        return {
          input: input,
          label: input.nextElementSibling,
          number: Number.parseFloat(input.value),
          index: index
        };
      });

      if (!entries.length || entries.some(function (entry) { return !Number.isFinite(entry.number); })) return;

      entries.sort(function (a, b) {
        return a.number === b.number ? a.index - b.index : a.number - b.number;
      });

      entries.forEach(function (entry) {
        container.appendChild(entry.input);
        if (entry.label) container.appendChild(entry.label);
      });
    });
  };

  DawnProduct.prototype.findSelectedVariant = function () {
    var selected = this.optionGroups.map(function (group) {
      var input = group.querySelector('[data-dp-option-input]:checked');
      return input ? input.value : null;
    });

    return this.variants.find(function (variant) {
      return variant.options.length === selected.length && variant.options.every(function (value, index) {
        return value === selected[index];
      });
    }) || null;
  };

  DawnProduct.prototype.updateVariant = function (variant, updateUrl) {
    this.currentVariant = variant;
    var available = Boolean(variant && variant.available);

    if (this.variantIdInput) {
      this.variantIdInput.value = variant ? variant.id : '';
      this.variantIdInput.disabled = !available;
      this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (variant) {
      this.price.textContent = this.formatMoney(variant.price);
      var onSale = Number(variant.compare_at_price) > Number(variant.price);
      this.comparePrice.textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';
      this.comparePrice.hidden = !onSale;
      this.saleBadge.hidden = !onSale;

      if (variant.featured_media_id) this.showMedia(Number(variant.featured_media_id), updateUrl);
      this.applyQuantityRules(variant);
    } else {
      this.price.textContent = '';
      this.comparePrice.hidden = true;
      this.saleBadge.hidden = true;
      if (this.inventory) this.inventory.textContent = this.config.strings.unavailable;
    }

    this.submitLabel.textContent = variant ? (available ? this.config.strings.add_to_cart : this.config.strings.sold_out) : this.config.strings.unavailable;
    this.updateOptionAvailability();
    this.validateQuantity(false);

    if (updateUrl && variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }
  };

  DawnProduct.prototype.updateOptionAvailability = function (repairSelection) {
    var self = this;
    var selected = [];

    this.optionGroups.forEach(function (group, groupIndex) {
      var states = Array.prototype.slice.call(group.querySelectorAll('[data-dp-option-input]')).map(function (input) {
        var matchingVariants = self.variants.filter(function (variant) {
          if (variant.options[groupIndex] !== input.value) return false;
          return selected.every(function (selectedValue, index) {
            return !selectedValue || variant.options[index] === selectedValue;
          });
        });

        var exists = matchingVariants.length > 0;
        var available = matchingVariants.some(function (variant) { return variant.available; });
        var label = input.nextElementSibling;
        input.disabled = !exists;

        if (label) {
          label.hidden = !exists;
          label.classList.toggle('is-unavailable', exists && !available);
          label.setAttribute('aria-disabled', available ? 'false' : 'true');
        }

        return { input: input, exists: exists, available: available };
      });

      var current = states.find(function (state) { return state.input.checked && state.exists; });
      if (repairSelection && !current) {
        current = states.find(function (state) { return state.exists && state.available; })
          || states.find(function (state) { return state.exists; });
        if (current) current.input.checked = true;
      }

      selected[groupIndex] = current ? current.input.value : null;
    });

    this.optionGroups.forEach(function (group) {
      var checked = group.querySelector('[data-dp-option-input]:checked');
      var value = group.querySelector('[data-dp-option-value]');
      if (value) value.textContent = checked ? checked.value : '';
    });
  };

  DawnProduct.prototype.applyQuantityRules = function (variant) {
    if (!this.quantityInput || !variant) return;

    var rule = variant.quantity_rule || {};
    var min = Number(rule.min) || 1;
    var step = Number(rule.increment) || 1;
    var max = rule.max == null ? null : Number(rule.max);
    var tracksInventory = variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';

    if (tracksInventory) {
      var inventoryMax = Math.max(0, Number(variant.inventory_quantity) || 0);
      max = max == null ? inventoryMax : Math.min(max, inventoryMax);
    }

    this.quantityInput.min = min;
    this.quantityInput.step = step;
    if (max == null) this.quantityInput.removeAttribute('max');
    else this.quantityInput.max = max;

    var current = Number(this.quantityInput.value);
    if (!Number.isFinite(current) || current < min) this.quantityInput.value = min;
    if (max != null && Number(this.quantityInput.value) > max) this.quantityInput.value = Math.max(min, max);

    if (this.inventory) {
      this.inventory.classList.toggle('is-sold-out', !variant.available);
      if (!variant.available) {
        this.inventory.textContent = this.config.strings.sold_out;
      } else if (tracksInventory) {
        this.inventory.textContent = this.config.strings.inventory_only.replace('[quantity]', Math.max(0, Number(variant.inventory_quantity) || 0));
      } else {
        this.inventory.textContent = this.config.strings.inventory;
      }
    }
  };

  DawnProduct.prototype.validateQuantity = function (showMessage) {
    if (!this.quantityInput) return true;

    var value = Number(this.quantityInput.value);
    var min = Number(this.quantityInput.min) || 1;
    var max = this.quantityInput.hasAttribute('max') ? Number(this.quantityInput.max) : null;
    var step = Number(this.quantityInput.step) || 1;
    var aligned = Number.isFinite(value) && Math.abs(((value - min) / step) - Math.round((value - min) / step)) < 0.00001;
    var valid = Number.isFinite(value) && value >= min && (max == null || value <= max) && aligned;

    if (this.quantityMessage) {
      this.quantityMessage.hidden = valid || !showMessage;
      if (!valid) {
        this.quantityMessage.textContent = this.config.strings.quantity_error
          .replace('[min]', min)
          .replace('[max]', max == null ? '∞' : max);
      }
    }

    this.updateSubmitState(valid);
    return valid;
  };

  DawnProduct.prototype.normalizeQuantity = function () {
    if (!this.quantityInput) return;
    var min = Number(this.quantityInput.min) || 1;
    var max = this.quantityInput.hasAttribute('max') ? Number(this.quantityInput.max) : null;
    var step = Number(this.quantityInput.step) || 1;
    var value = Number(this.quantityInput.value);
    if (!Number.isFinite(value)) value = min;
    value = min + Math.round((value - min) / step) * step;
    value = Math.max(min, value);
    if (max != null) value = Math.min(max, value);
    this.quantityInput.value = value;
    this.validateQuantity(false);
  };

  DawnProduct.prototype.stepQuantity = function (direction) {
    if (!this.quantityInput) return;
    var step = Number(this.quantityInput.step) || 1;
    var value = Number(this.quantityInput.value) || Number(this.quantityInput.min) || 1;
    this.quantityInput.value = value + direction * step;
    this.normalizeQuantity();
  };

  DawnProduct.prototype.updateSubmitState = function (quantityValid) {
    if (!this.submitButton) return;
    var available = Boolean(this.currentVariant && this.currentVariant.available);
    this.submitButton.disabled = this.loading || !available || !quantityValid;
  };

  DawnProduct.prototype.showMedia = function (mediaId, scrollToMedia) {
    var media = this.root.querySelector('[data-dp-media-id="' + mediaId + '"]');
    if (!media) return;

    this.root.querySelectorAll('[data-dp-media-id]').forEach(function (item) {
      var selected = item === media;
      item.classList.toggle('is-selected', selected);
      if (!selected) item.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });

    if (scrollToMedia && typeof media.scrollIntoView === 'function') {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      media.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
    }
  };

  DawnProduct.prototype.setupRecipientForm = function () {
    var self = this;
    var recipient = this.root.querySelector('[data-dp-recipient]');
    if (!recipient) return;

    var toggle = recipient.querySelector('[data-dp-recipient-toggle]');
    var fields = recipient.querySelector('[data-dp-recipient-fields]');
    var controls = recipient.querySelectorAll('[data-dp-recipient-field], [data-dp-recipient-control], [data-dp-recipient-offset]');
    var email = recipient.querySelector('input[type="email"]');
    var offset = recipient.querySelector('[data-dp-recipient-offset]');
    var sendOn = recipient.querySelector('[data-dp-send-on]');

    if (offset) offset.value = String(new Date().getTimezoneOffset());
    if (sendOn) sendOn.min = new Date().toISOString().slice(0, 10);

    toggle.addEventListener('change', function () {
      fields.hidden = !toggle.checked;
      controls.forEach(function (control) { control.disabled = !toggle.checked; });
      if (email) email.required = toggle.checked;
      if (!toggle.checked) {
        recipient.querySelectorAll('input:not([type="checkbox"]), textarea').forEach(function (input) { input.value = ''; });
      }
      self.clearFormError();
    });
  };

  DawnProduct.prototype.addToCart = function (event) {
    var self = this;
    event.preventDefault();
    this.clearFormError();

    if (!this.currentVariant || !this.currentVariant.available || !this.validateQuantity(true)) return;
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.setLoading(true);
    var formData = new FormData(this.form);
    var addUrl = jsonEndpoint(this.config.cart_add_url);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok || payload.status) throw new Error(payload.description || payload.message || self.config.strings.cart_error);
          return payload;
        });
      })
      .then(function (item) {
        return fetch(jsonEndpoint(self.config.cart_url), { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; })
          .then(function (cart) {
            if (cart) self.updateHeaderCartCount(cart.item_count);
            self.openNotification(item, cart);
          });
      })
      .catch(function (error) {
        self.showFormError(error.message || self.config.strings.cart_error);
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  DawnProduct.prototype.setLoading = function (loading) {
    this.loading = loading;
    this.submitButton.classList.toggle('is-loading', loading);
    this.spinner.hidden = !loading;
    this.submitButton.setAttribute('aria-busy', loading ? 'true' : 'false');
    this.validateQuantity(false);
  };

  DawnProduct.prototype.showFormError = function (message) {
    this.formError.textContent = message;
    this.formError.hidden = false;
    this.formError.focus();
  };

  DawnProduct.prototype.clearFormError = function () {
    this.formError.textContent = '';
    this.formError.hidden = true;
  };

  DawnProduct.prototype.updateHeaderCartCount = function (count) {
    var cartLink = document.querySelector('.site-header__cart');
    if (!cartLink) return;

    var badge = document.getElementById('CartCount');
    if (!badge && count > 0) {
      badge = document.createElement('div');
      badge.id = 'CartCount';
      badge.className = 'site-header__cart-count';
      var visibleCount = document.createElement('span');
      badge.appendChild(visibleCount);
      var accessibleCount = document.createElement('span');
      accessibleCount.className = 'icon__fallback-text medium-up--hide';
      badge.appendChild(accessibleCount);
      cartLink.appendChild(badge);
    }

    if (badge) {
      var spans = badge.querySelectorAll('span');
      if (spans[0]) spans[0].textContent = count;
      if (spans[1]) spans[1].textContent = count + (count === 1 ? ' item' : ' items');
      badge.hidden = count < 1;
    }
  };

  DawnProduct.prototype.openNotification = function (item, cart) {
    if (!this.notification) return;
    this.lastFocusedElement = document.activeElement;

    var image = this.notification.querySelector('[data-dp-notification-image]');
    var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
    image.hidden = !imageUrl;
    if (imageUrl) {
      image.src = imageUrl;
      image.alt = item.product_title || item.title || '';
    }

    this.notification.querySelector('[data-dp-notification-product-title]').textContent = item.product_title || item.title || '';
    var variant = this.notification.querySelector('[data-dp-notification-variant]');
    variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    variant.hidden = !variant.textContent;
    var linePrice = item.final_line_price != null ? item.final_line_price : Number(item.price || 0) * Number(item.quantity || 1);
    this.notification.querySelector('[data-dp-notification-price]').textContent = this.formatMoney(linePrice);
    this.notification.querySelector('[data-dp-cart-count]').textContent = cart ? '(' + cart.item_count + ')' : '';

    this.notification.hidden = false;
    var close = this.notification.querySelector('[data-dp-notification-close]');
    if (close) close.focus();
  };

  DawnProduct.prototype.closeNotification = function () {
    if (!this.notification || this.notification.hidden) return;
    this.notification.hidden = true;
    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') this.lastFocusedElement.focus();
  };

  DawnProduct.prototype.openZoom = function (button) {
    if (!this.zoomDialog) return;
    var image = this.zoomDialog.querySelector('[data-dp-zoom-image]');
    var sourceImage = button.querySelector('img');
    image.src = button.getAttribute('data-dp-zoom-src');
    image.alt = sourceImage ? sourceImage.alt : '';
    if (typeof this.zoomDialog.showModal === 'function') this.zoomDialog.showModal();
    else this.zoomDialog.setAttribute('open', 'open');
  };

  DawnProduct.prototype.closeZoom = function () {
    if (!this.zoomDialog) return;
    if (typeof this.zoomDialog.close === 'function' && this.zoomDialog.open) this.zoomDialog.close();
    else this.zoomDialog.removeAttribute('open');
  };

  DawnProduct.prototype.share = function (button) {
    var self = this;
    var url = button.getAttribute('data-share-url') || window.location.href;
    var status = this.root.querySelector('[data-dp-share-status]');

    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        if (status) status.textContent = self.config.strings.share_success;
      }).catch(function () {
        if (status) status.textContent = url;
      });
    } else if (status) {
      status.textContent = url;
    }
  };

  DawnProduct.prototype.formatMoney = function (cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, this.config.money_format);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.config.currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2);
    }
  };

  function parseJson(element) {
    if (!element) return {};
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Unable to read Dawn product data', error);
      return {};
    }
  }

  function jsonEndpoint(url) {
    if (!url) return '';
    return /\.js(?:\?|$)/.test(url) ? url : url.replace(/\/$/, '') + '.js';
  }

  function loadRecommendations(section) {
    var url = section.getAttribute('data-url');
    if (!url || section.querySelector('.dp-recommendations-grid')) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var incoming = documentFragment.querySelector('[data-dp-recommendations]');
        if (incoming && incoming.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
      })
      .catch(function () {
        // Recommendations are an optional enhancement; keep the empty section hidden.
      });
  }

  document.querySelectorAll('[data-dp-root]').forEach(function (root) {
    new DawnProduct(root);
  });

  document.querySelectorAll('[data-dp-recommendations]').forEach(loadRecommendations);
})();
